import { createAction } from "@reduxjs/toolkit";

export const changeSoundLevel = createAction<number>("media/sound-level");
